<template>
  <form
    :method="method"
    :enctype="enctype"
    :action="action"
    :target="target"
    :name="name"
    @submit.prevent="submit"
    :scope="scope"
    ref="form"
  >
    <input type="hidden" name="_token" :value="token">
    <slot></slot>
  </form>
</template>

<script>
export default {
  name: 'form-area',
  data() {
    return {
      token: window.Laravel.csrfToken
    }
  },
  props: {
    method: String,
    enctype: String,
    action: String,
    target: String,
    name: String,
    scope: { type: String, default: '' },
    nativeSubmit: { type: Boolean, default: true }
  },
  mounted() {
    this.onMounted()
  },
  methods: {
    onMounted() {},
    submit($event) {
      //On button pressed run validation
      this.$validator.validateAll().then(result => {
        if (result === false) {
          const errors = this.$validator.errors.items
          const $errorsElm = $(`[data-vv-id="${errors[0].id}"]`)
          $('html, body').animate(
            {
              scrollTop: $errorsElm[0] ? $errorsElm.offset().top - 56 : 0
            },
            300
          )
        } else {
          this.$emit('submit', $event)
          if (this.nativeSubmit) {
            this.$refs.form.submit()
          }
        }
      })
    }
  }
}</script>

<style>

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/forms/FormArea.vue